import '../../../jello/node_modules/bootstrap';
import detectIt from 'detect-it';
import MenuTabs from './menu-tabs';

export default class Menu {
  constructor() {
    this.mainMenu = $('.menu-primary');
    this.metaMenu = $('.menu-meta-wrap');
    this.menuToggler = $('.navbar-toggler');
    this.header = $('header.header');

    this.handleSizes();
    Menu.handleDevices();
  }

  static handleDevices() {
    if (detectIt.deviceType === 'touchOnly') {
      Menu.addTouchFunctionality();
    }
  }

  handleSizes() {
    if ($(window).width() < 1200) {
      this.repeatParentInSubmenu();
      this.moveMetaToMain();
      this.menuTabs = new MenuTabs();
    } else if (this.menuTabs) {
      this.menuTabs.destroy();
    }

    if ($(window).width() < 768) {
      this.menuToggler.on('click', () => this.setFixedMenu());
    }

    if ($(window).width() > 1200) {
      $('> .menu-item-has-children', this.mainMenu).on('mouseenter mouseleave', (e) => {
        Menu.centerDropdownIfOutOfView(e);
      });
    }
  }

  /**
   * Meta menu gets added to the mobile menu,
   * this function places it back
   */
  static placeMetaBack() {
    const $meta = $('.menu-meta');
    const $main = $('.menu-main');
    const $mobileMenu = $('.header .menu-main-container');

    $($meta, $mobileMenu).insertAfter($main);
    $meta.removeClass('visible');
  }

  repeatParentInSubmenu() {
    const parents = $('.menu-item-has-children > .nav-link', this.mainMenu);
    
    parents.each(function repeatParent() {
      let holder = $('+ .sub-menu', $(this));
      if ($('> .nav-col', holder)) {
        holder = $('> .nav-col > .sub-menu', holder);
      }

      $(this)
        .clone()
        .prependTo(holder.eq(0))
        .wrap('<li></li>')
        .parent()
        .addClass($(this).parent().attr('class'))
        .addClass('menu-item-copied')
        .removeClass('menu-item-has-children nav-cols');
    });
  }

  moveMetaToMain() {
    this.metaMenu = this.mainMenu.after(this.metaMenu);
  }

  static centerDropdownIfOutOfView(e) {
    const el = $(e.currentTarget);
    const submenu = $('> .sub-menu-wrap', el);
    const screenWidth = $(window).width();
    const submenuWidth = submenu.width();
    const submenuOffset = submenu.offset().left;

    if (submenu.hasClass('centered-dropdown')) {
      return;
    }


    if (submenuOffset < 0 || submenuWidth + submenuOffset > screenWidth) {
      submenu
        .addClass('centered-dropdown')
        .parents('.menu-item')
        .addClass('has-centered-dropdown');
    }
  }

  /**
   * Sets up the menu so users with touch devices can
   * reveal submenus without navigating away.
   * 
   * @todo Close submenu when clicking the link again
   */
  static addTouchFunctionality() {
    const itemWithChildren = $('.menu > .menu-item-has-children > a');

    itemWithChildren.on('click', (e) => {
      e.preventDefault();
    });
  }

  setFixedMenu() {
    this.header.toggleClass('menu-toggled', this.menuToggler.hasClass('collapsed'));
  }
}
